import { Box, useColorModeValue } from "@chakra-ui/react";
import {
  Children,
  cloneElement,
  isValidElement,
  memo,
  useContext,
  useMemo,
} from "react";
import { RTableContext } from "./RTableContext";
import { RTrContext } from "./RTrContext";

const RTr = memo(
  /**
   * @typedef {Object} Props
   * @property {boolean} [_isFirstRow]
   * @property {boolean} [_isLastRow]
   * @property {import("react").ReactNode} children
   *
   * @param {Props} props
   */
  function RTr({ _isFirstRow = false, _isLastRow = false, children }) {
    const { responsiveBreakpoint, isStriped } = useContext(RTableContext);

    const value = useMemo(() => {
      return {
        isFirstRow: _isFirstRow,
        isLastRow: _isLastRow,
      };
    }, [_isFirstRow, _isLastRow]);

    const backgroundColor = useColorModeValue("brandPrimary.50", "gray.700");

    return (
      <RTrContext.Provider value={value}>
        <Box
          display="table-row"
          sx={{
            "&:nth-of-type(odd)": {
              backgroundColor: isStriped ? backgroundColor : undefined,
            },
            [`@container (max-width: ${responsiveBreakpoint})`]: {
              "&": {
                display: "block",
              },
              "&:not(:last-of-type)": {
                borderBottomWidth: isStriped ? undefined : "1px",
              },
            },
          }}>
          {Children.toArray(children).map(
            (child, index) =>
              isValidElement(child) &&
              cloneElement(child, {
                _columnIndex: index,
              }),
          )}
        </Box>
      </RTrContext.Provider>
    );
  },
);

export default RTr;
